export const convertFieldByDistanceType = (field, distanceType) => {
    if(!distanceType) return field
    if(field?.textGRAppendByUnit) {
        field.textGRAppend = field.textGRAppendByUnit?.[distanceType]
    }
    if(field.option?.length > 0) {
        field.option = field.option.map(option => {
            if(option.textByDistanceUnit) option.text = option.textByDistanceUnit?.[distanceType]
            return option
        })
    }
    if(field.titleByDistanceUnit) {
        field.title = field.titleByDistanceUnit?.[distanceType]
    }
    return field
}